import { FC } from 'react';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import ParticipantMessage from './ParticipantMessage';

type Props = {
  message: HeroConversationMessage;
};

const TextMessage: FC<Props> = ({ message }) => (
  <ParticipantMessage message={message} />
);

export default TextMessage;
